export default "__VITE_ASSET__BwnnX1Yb__"